import { Component } from '@angular/core';

@Component({
  selector: 'app-user-view-and-edit',
  templateUrl: './user-view-and-edit.component.html',
  styleUrls: ['./user-view-and-edit.component.scss']
})
export class UserViewAndEditComponent {

}
